module.exports = __webpack_public_path__ + "static/plants-b81a031ce592ef192176965ad45cbf2a.png";